import { Fragment, useEffect, useState } from 'react';
import { toAbsoluteUrl } from '@/utils';
import { FeaturesHighlight } from '@/pages/public-profile/profiles/creator';
import { Authentification, TrustedDevices } from './blocks';
import settingService from '@/services/setting/settingService';
import { toast } from 'sonner';
import { useIntl } from 'react-intl';
import { isSuperAdmin } from '@/utils';

const AccountOverviewContent = () => {
  const [sessionData, setSessionData] = useState(null)
  const [loading, setLoading] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const { formatMessage } = useIntl();

  const getUserSessions = async () => {
    try {
      setLoading(true)
      const { data, status } = isSuperAdmin()
        ? await settingService.superAdminUserSessions()
        : await settingService.userSessions();
      if (status) {
        setSessionData(data)
      } else {
        toast.error(formatMessage({ id: 'login_sessions.failed_to_fetch_sessions' }), {
          description: formatMessage({ id: 'login_sessions.error_fetching_sessions' }),
        });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(formatMessage({ id: 'login_sessions.failed_to_fetch_sessions' }), {
        description: formatMessage({ id: 'login_sessions.error_fetching_sessions' }),
      });
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteSession = async (id) => {
    try {
      const { status } = isSuperAdmin()
        ? await settingService.superAdminDeleteSession(id)
        : await settingService.deleteSession(id);
      if (status) {
        getUserSessions()
        toast.success(formatMessage({ id: 'login_sessions.session_deleted_successfully' }), {
          description: formatMessage({ id: 'login_sessions.user_login_session_deleted_successfully' }),

        });
      } else {
        toast.error(formatMessage({ id: 'login_sessions.failed_to_delete_session' }), {
          description: formatMessage({ id: 'login_sessions.error_deleting_session' }),
        });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(formatMessage({ id: 'login_sessions.failed_to_delete_session' }), {
        description: formatMessage({ id: 'login_sessions.error_deleting_session' }),
      });
    }
  }

  const handleDeleteAllSession = async () => {
    try {
      setIsLoading(true)
      const { status } = isSuperAdmin()
        ? await settingService.superAdminDeleteAllSession()
        : await settingService.deleteAllSession();
      if (status) {
        getUserSessions()
        toast.success(formatMessage({ id: 'login_sessions.all_sessions_deleted_successfully' }), {
          description: formatMessage({ id: 'login_sessions.all_user_login_sessions_deleted_successfully' }),

        });
      } else {
        toast.error(formatMessage({ id: 'login_sessions.failed_to_delete_session' }), {
          description: formatMessage({ id: 'login_sessions.error_deleting_session' }),
        });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(formatMessage({ id: 'login_sessions.failed_to_delete_session' }), {
        description: formatMessage({ id: 'login_sessions.error_deleting_session' }),
      });
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getUserSessions()
  }, [])


  return <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 lg:gap-7.5">
    <div className="col-span-3">
      <div className="flex flex-col gap-5 lg:gap-7.5">
        {/* image={<Fragment>
          <img src={toAbsoluteUrl('/media/illustrations/5.svg')} className="dark:hidden max-h-36" alt="" />
          <img src={toAbsoluteUrl('/media/illustrations/5-dark.svg')} className="light:hidden max-h-36" alt="" />
        </Fragment>} */}
        <FeaturesHighlight title={formatMessage({ id: 'account_security.essential_security_tips' })} description={formatMessage({ id: 'account_security.protect_your_account' })} features={[[formatMessage({ id: 'account_security.strong_password' }), formatMessage({ id: 'account_security.two_factor_authentication' })], [formatMessage({ id: 'account_security.password_reset' }), formatMessage({ id: 'account_security.secure_login_sessions' })]]} />
        {/* more={{
          title: 'Review Security Tips',
          url: '#'
        }} */}
        {/* <GeneralSettings /> */}

        <Authentification />

        {/* <QuickSettings /> */}

        {/* <LoginSessions /> */}

        <TrustedDevices data={sessionData} loading={loading} deleteSession={handleDeleteSession} deleteAllSessions={handleDeleteAllSession} isLoading={isLoading} />
      </div>
    </div>
    {/* <div className="col-span-1">
        <div className="flex flex-col gap-5 lg:gap-7.5">
          <ProductInsight image={<Fragment>
                <img src={toAbsoluteUrl('/media/brand-logos/apple-black.svg')} className="dark:hidden h-5" alt="" />
                <img src={toAbsoluteUrl('/media/brand-logos/apple-white.svg')} className="light:hidden h-5" alt="" />
              </Fragment>} title="iOS" description="Active Sessions" number={24} />

          <ProductInsight image={<img src={toAbsoluteUrl('/media/brand-logos/android.svg')} className="h-5" alt="" />} title="Android" description="Active Sessions" number={35} />

          <MiscHighlightedPosts posts={posts} />
        </div>
      </div> */}
  </div>;
};
export { AccountOverviewContent };